const reportWebVitals = () => {
  // This file is intentionally left empty to resolve compilation errors
  // related to the web-vitals package. The performance reporting
  // is not critical for the application's core functionality.
};

export default reportWebVitals;
